import React from 'react';
import PresetFormSimple from './scheduleComponents/PresetFormSimple';
import PresetSelector from './scheduleComponents/PresetSelector';
import SchedulePicker from './scheduleComponents/SchedulePicker';
import ScheduleTable168 from './scheduleComponents/ScheduleTable168';
import { useParams } from 'react-router-dom';
import {
  fetchUserSchedules,
  setScheduleModalopen,
  fetchControllerSchedules,
  clearSchedulesData,
  fetchCurrentData,
} from 'stores/sensor/controllersSlice';
import { ControllerCurrentDataFields } from 'types/ControllerFields.js';
import {
  getSchedulesByDeviceId,
  isCacheStale,
  getSchedule,
} from '../../../components/Schedule/schedulesCache';
import { Box, Typography } from '@mui/material';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const WeeklySchedule = () => {
  // const hourlyPresetsArray = useSelector(state => state.controllers.hourlyPresetsArray);
  // console.log('hourlyPresetsArray:', hourlyPresetsArray);
  const dispatch = useDispatch();
  const deviceId = useParams().id;
  const [newScheduleMode, setNewScheduleMode] = useState(false);
  // const [editScheduleMode, setEditScheduleMode] = useState(newScheduleMode);
  const [isRecommendationChanged, setIsRecommendationChanged] = useState(false);
  const [isRecommendationInEditMode, setIsRecommendationInEditMode] = useState(false);
  const [tempRecommendation, setTempRecommendation] = useState(null);
  const scheduleTableRef = useRef(null);

  useEffect(() => {
    dispatch(setScheduleModalopen(true));

    if (status === 'idle' || isCacheStale()) {
      // dispatch(fetchUserSchedules());
      dispatch(fetchControllerSchedules({ deviceId, includePatterns: true }));
    }
    return () => {
      dispatch(setScheduleModalopen(false));
      dispatch(clearSchedulesData());
    };
  }, []);

  const status = useSelector(s => s.controllers.schedulesStatus || 'idle');
  const schedulesIds = useSelector(s => s.controllers.schedulesIds || []);

  // useEffect(() => {
  //   if (status === 'idle' || isCacheStale()) {
  //     // dispatch(fetchUserSchedules());
  //     dispatch(fetchControllerSchedules({ deviceId, includePatterns: true }));
  //   }
  // }, [deviceId, schedulesIds]);

  // if (status !== 'succeeded') return <Typography>Loading...</Typography>;

  const deviceSchedules = useMemo(() => {
    if (status !== 'succeeded') return [];
    if (!deviceId || schedulesIds.length === 0) return [];
    let schedules = [];
    schedulesIds.forEach(id => {
      schedules.push(getSchedule(id));
    });

    // const schedules = getSchedulesByDeviceId(deviceId);
    return schedules;
  }, [deviceId, schedulesIds, status]);

  const triggerSaveSchedule = (triggerSource, payload) => {
    return scheduleTableRef.current?.saveSchedule(triggerSource, payload);
  };

  return (
    <Box sx={{ padding: '1rem' }}>
      <SchedulePicker
        deviceId={deviceId}
        deviceSchedules={deviceSchedules}
        newScheduleMode={newScheduleMode}
        setNewScheduleMode={setNewScheduleMode}
        isRecommendationChanged={isRecommendationChanged}
        setIsRecommendationChanged={setIsRecommendationChanged}
        triggerSaveSchedule={triggerSaveSchedule}
        isRecommendationInEditMode={isRecommendationInEditMode}
        setIsRecommendationInEditMode={setIsRecommendationInEditMode}
        tempRecommendation={tempRecommendation}
        setTempRecommendation={setTempRecommendation}></SchedulePicker>
      <PresetSelector
        newScheduleMode={newScheduleMode}
        setNewScheduleMode={setNewScheduleMode}
        isRecommendationInEditMode={isRecommendationInEditMode}></PresetSelector>
      <ScheduleTable168
        deviceId={deviceId}
        ref={scheduleTableRef}
        newScheduleMode={newScheduleMode}
        setNewScheduleMode={setNewScheduleMode}
        isRecommendationInEditMode={isRecommendationInEditMode}
        isRecommendationChanged={isRecommendationChanged}
        setIsRecommendationChanged={setIsRecommendationChanged}
        setIsRecommendationInEditMode={setIsRecommendationInEditMode} // in use
        tempRecommendation={tempRecommendation}></ScheduleTable168>
      {newScheduleMode && <PresetFormSimple></PresetFormSimple>}
    </Box>
  );
};

export default React.memo(WeeklySchedule);
